const spriteContext = require.context(
    '@/assets/sprite',
    false,
    /\.png$/
)

const imageCache = new Map()
const loadingPromises = new Map()

export function loadSpriteSheet(spriteSheetName) {
    if (imageCache.has(spriteSheetName)) {
        return Promise.resolve(imageCache.get(spriteSheetName))
    }

    if (loadingPromises.has(spriteSheetName)) {
        return loadingPromises.get(spriteSheetName)
    }

    const localLoadPromise = new Promise((resolve, reject) => {
        try {
            const webpackPath = `./${spriteSheetName}`
            const imageModule = spriteContext(webpackPath)
            const imageUrl = imageModule.default || imageModule

            const img = new Image()
            img.crossOrigin = 'anonymous'

            img.onload = () => {
                // console.log(`Sprite loaded: ${spriteSheetName}`)
                imageCache.set(spriteSheetName, img)
                loadingPromises.delete(spriteSheetName)
                resolve(img)
            }

            img.onerror = (err) => {
                console.log(`Sprite load failed: ${spriteSheetName}`)
                loadingPromises.delete(spriteSheetName)
                reject(err)
            }

            img.src = imageUrl
        } catch (err) {
            loadingPromises.delete(spriteSheetName)
            reject(err)
        }
    })

    loadingPromises.set(spriteSheetName, localLoadPromise)
    return localLoadPromise
}

export function loadNetImage(url) {
    if (imageCache.has(url)) {
        return Promise.resolve(imageCache.get(url))
    }

    if (loadingPromises.has(url)) {
        return loadingPromises.get(url)
    }

    const networkLoadPromise = new Promise((resolve, reject) => {
        try {
            const img = new Image()
            img.crossOrigin = 'anonymous'

            img.onload = () => {
                // console.log(`Url loaded: ${spriteSheetName}`)
                const imgWidth = img.naturalWidth
                const imgHeight = img.naturalHeight
                const targetSize = 144

                const scale = targetSize / Math.min(imgWidth, imgHeight)

                const scaledWidth = Math.round(imgWidth * scale)
                const scaledHeight = Math.round(imgHeight * scale)

                const sx = Math.max(0, Math.round((scaledWidth - targetSize) / 2))
                const sy = Math.max(0, Math.round((scaledHeight - targetSize) / 2))

                const offscreenCanvas = document.createElement('canvas')
                offscreenCanvas.width = targetSize
                offscreenCanvas.height = targetSize
                const offscreenCtx = offscreenCanvas.getContext('2d')

                offscreenCtx.imageSmoothingEnabled = true
                offscreenCtx.imageSmoothingQuality = 'high'

                offscreenCtx.drawImage(
                    img,
                    0, 0, imgWidth, imgHeight,
                    -sx, -sy, scaledWidth, scaledHeight
                )

                offscreenCanvas.toBlob((blob) => {
                    if (!blob) {
                        reject(new Error('Canvas toBlob failed'))
                        return
                    }

                    const compressedUrl = URL.createObjectURL(blob)
                    const compressedImg = new Image()

                    // 标记这是压缩后的图片，方便后续清理
                    compressedImg._compressed = true
                    compressedImg._objectURL = compressedUrl

                    compressedImg.onload = () => {
                        imageCache.set(url, compressedImg)
                        loadingPromises.delete(url)

                        URL.revokeObjectURL(compressedUrl)
                        resolve(compressedImg)
                    }

                    compressedImg.onerror = (err) => {
                        URL.revokeObjectURL(compressedUrl)
                        reject(err)
                    }

                    compressedImg.src = compressedUrl
                }, 'image/png')
            }

            img.onerror = (err) => {
                console.log(`Url load failed: ${url}`)
                loadingPromises.delete(url)
                reject(err)
            }

            img.src = url
        } catch (err) {
            loadingPromises.delete(url)
            reject(err)
        }
    })

    loadingPromises.set(url, networkLoadPromise)
    return networkLoadPromise
}

export function drawIcon(
    ctx, spriteImage,
    sx, sy, sw, sh,
    dx = 0, dy = 0,
    scale = 1
) {
    if (!spriteImage || !spriteImage.complete) {
        console.warn('Sprite image not loaded')
        return
    }

    const dw = sw * scale
    const dh = sh * scale

    ctx.imageSmoothingEnabled = false
    ctx.drawImage(
        spriteImage,
        sx, sy, sw, sh,
        dx, dy, dw, dh
    )
}

export function drawCircleAvatar (
    ctx, image,
    sx, sy, sw, sh,
    dx = 0, dy = 0,
    scale = 1,
    borderColor = '#ffffff',
    borderWidth = 2
) {
    if (!image || !image.complete) {
        console.warn('Sprite image not loaded')
        return
    }

    const dw = sw * scale
    const dh = sh * scale
    const radius = dw / 2

    const centerX = dx + radius
    const centerY = dy + radius

    ctx.save()

    ctx.beginPath()
    ctx.arc(centerX, centerY, radius - borderWidth / 2, 0, Math.PI * 2)
    ctx.closePath()
    ctx.clip()

    ctx.imageSmoothingEnabled = true
    ctx.imageSmoothingQuality = 'high'

    ctx.drawImage(
        image,
        sx, sy, sw, sh,
        dx, dy, dw, dh
    )

    ctx.restore()

    ctx.beginPath()
    ctx.arc(centerX, centerY, radius - borderWidth / 2, 0, Math.PI * 2)
    ctx.lineWidth = borderWidth
    ctx.strokeStyle = borderColor
    ctx.stroke()
}